import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { ConfirmDialog } from "src/components/custom-dialog";
import Iconify from "src/components/iconify";
import { useBoolean } from "src/hooks/use-boolean";

const ModuleFeatureList = ({ tableData, moduleData, onDelete, onEdit, index }) => {
  const [ expanded, setExpanded ] = useState(true);
  const confirm = useBoolean();
  return (<>
    <Accordion
      style={ {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        marginBottom: "10px"
      } }

      expanded={ expanded }
      onChange={ () => setExpanded(!expanded) }
    >
      <AccordionSummary
        expandIcon={
          <IconButton >
            <Iconify icon="eva:arrow-circle-down-fill" width={ 24 } />
          </IconButton>
        }
        sx={ { display: "flex", alignItems: "center", width: "100%" } }
      >
        <Typography variant="h6" sx={ { flexGrow: 1 } }>
          { moduleData.module_name }
        </Typography>
        <Stack direction="row" spacing={ 1 }>
          <IconButton
            onClick={ (e) => {
              e.stopPropagation(); // prevent collapse
              onEdit(moduleData.module_name);
            } }
          >
            <Iconify icon="solar:pen-bold" />
          </IconButton>

          <IconButton
            onClick={ (e) => {
              e.stopPropagation();
              confirm.onTrue();
            } }
          >
            <Iconify icon="solar:trash-bin-trash-bold" />
          </IconButton>

        </Stack>
      </AccordionSummary>

      <AccordionDetails>
        <Grid container spacing={ 2 }>
          { moduleData?.feature_list?.map((item, index) => (
            <Grid key={ index } item xs={ 12 } sm={ 4 }

            >
              <Paper
                elevation={ 2 }
                sx={ {
                  p: 1,
                  display: "flex",
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                } }
              >
                {/* Feature Name */ }
                <Stack direction="row" spacing={ 1 } alignItems="center" sx={ { flex: 1, } }>
                  <Iconify icon="material-symbols:admin-panel-settings-rounded" width={ 18 } sx={ { color: "text.disabled" } } />
                  <Typography variant="body2">{ item.feature_name }</Typography>
                </Stack>

                {/* Feature Cost */ }
                <Stack direction="row" spacing={ 0 } alignItems="center" sx={ { justifyContent: "center", marginRight: '5px' } }>
                  <Iconify icon="mdi:currency-usd" width={ 18 } sx={ { color: "text.disabled" } } />
                  <Typography variant="body2">{ item.cost }</Typography>
                </Stack>

                {/* Created Date */ }
                <Stack direction="row" spacing={ 1 } alignItems="center" sx={ { justifyContent: "flex-end" } }>
                  <Iconify icon="mdi:calendar-month" width={ 18 } sx={ { color: "text.disabled" } } />
                  <Typography variant="body2">{ item.created_date }</Typography>
                </Stack>
              </Paper>
            </Grid>
          )) }
        </Grid>
      </AccordionDetails>
    </Accordion >

    <ConfirmDialog
      open={ confirm.value }
      onClose={ confirm.onFalse }
      title="Delete"
      content="Are you sure want to delete?"
      action={
        <Button variant="contained"
          onClick={ (e) => {
            e.stopPropagation();
            onDelete(index, moduleData.id);
          } }>
          Delete
        </Button >
      }
    />
  </>
  );
};

export default ModuleFeatureList;
